<template>
  <div id="print"  style="overflow-x: scroll;">
    
  </div>
</template>

<script>
export default {
  name: 'SavePDF',
  props: ['fields','items','filter','sortBy','sortDesc','onFiltered'],
  mounted() {
    this.$root.$on("savePDFClicked", () => {
      // this.fields = fields;
      // this.items = items;
      // this.filter = filter;
      // this.sortDesc = sortDesc
      // this.sortBy = sortBy;
      console.log("this.stores ", this.items);
      if (this.items) {
        setTimeout(() => {
          this.PrintElem("realtable");
        }, 200);
      }
    });
  },
  methods: {
    PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes",);

      mywindow.document.write(
        "<html><head><title>" + document.title + "</title>"
      );

      
      mywindow.document.write(
        `<link rel="stylesheet" href="../../../../static/bootstrap-vue.css" type="text/css" />`
      );
      // mywindow.document.write(
      //   `<link rel='stylesheet' href='../../../../static/bootstrap4.min.css' type="text/css" />`
      // );
      mywindow.document.write(
        `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.1.3/dist/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">`
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();

      return true;
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/admin/SavePDF.vue